module.exports = __webpack_public_path__ + "static/img/page_READ02.c8272c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series5/course2/page_READ02.png
// module id = yFEQ
// module chunks = 0